import { AxiosResponse } from "axios";
import { IOptions } from "../../api-sdk";
import BaseService from "../baseService";
import {
  IGetImportJobs,
  IImportJob,
  IImportJobResponse,
  IImportPayload,
  IImportFailedRow,
} from "./import.types";
import { IPaginatedResponse } from "../../../types";
import { filterNonNull } from "../../../utils";
import qs from "qs";

class ImportService extends BaseService {
  constructor(options: IOptions) {
    super(options);
  }

  /**
   * Creates a new import job.
   * @param payload The payload to send to the server.
   * @returns A promise that resolves to the server's response containing the import job details.
   */
  async import(
    payload: IImportPayload
  ): Promise<AxiosResponse<IImportJobResponse>> {
    return this.request({
      method: "POST",
      url: "/api/v1/import",
      data: payload,
    });
  }

  /**
   * Retrieves a list of import jobs.
   * @param query The query to filter the results by.
   * @returns A promise that resolves to the server's response containing the list of import jobs.
   */
  async getImportJobs(
    query?: IGetImportJobs & { findFailedRowsByJobId: string }
  ): Promise<AxiosResponse<IPaginatedResponse<IImportFailedRow>>>;
  async getImportJobs(
    query?: IGetImportJobs
  ): Promise<AxiosResponse<IPaginatedResponse<IImportJob>>>;
  async getImportJobs(
    query?: IGetImportJobs
  ): Promise<
    AxiosResponse<
      IPaginatedResponse<IImportJob> | IPaginatedResponse<IImportFailedRow>
    >
  > {
    return this.request({
      method: "GET",
      url: `/api/v1/import/jobs?${qs.stringify(filterNonNull(query ?? {}))}`,
    });
  }
}

export default ImportService;
